import { useState } from 'react'
import { NumberField } from '@adobe/react-spectrum'

const Stepper = ({
  label,
  defaultValue,
  value,
  minValue,
  onChange,
  step = 0.001,
  shiftStep = 1,
}: {
  label: string
  defaultValue: number
  value: number
  minValue?: number
  onChange: (axis: string, value: number) => void
  step?: number
  shiftStep?: number
}) => {
  const [shiftKeyPressed, setShiftKeyPressed] = useState(false)

  const handleOnChange = (newValue: number) => {
    const shiftStepValue = newValue < value ? -shiftStep : shiftStep
    onChange(
      label.toLocaleLowerCase(),
      shiftKeyPressed ? value + shiftStepValue : newValue
    )
  }

  return (
    <NumberField
      value={value}
      minValue={minValue}
      onChange={handleOnChange}
      defaultValue={defaultValue}
      label={label}
      step={step}
      onKeyUp={(e) => {
        if (e.key === 'Shift') {
          setShiftKeyPressed(false)
        }
        if (e.key === 'ArrowUp' && shiftKeyPressed) {
          handleOnChange(value + step)
        }
        if (e.key === 'ArrowDown' && shiftKeyPressed) {
          handleOnChange(value - step)
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Shift') {
          setShiftKeyPressed(true)
        }
      }}
      onBlur={() => setShiftKeyPressed(false)}
      width={'size-1250'}
    />
  )
}

export { Stepper }
